 function newPoints(passport) {

     var bars = $('#npb>i.calc');
     var barscount = $('#npb').data('count');
     var animation_time = 100;
     var pointsoutput = $('#numcount');
     var ptitle = $('.points-title');

     var basepoints = 0;
     var eventpoints = 0;
     var bonuspoints = 0;

     var firstname = passport.firstname +'\'s ';
     firstname = '';

     var easeOutCubic = function(t, b, c, d) {
         var ts = (t /= d) * t;
         var tc = ts * t;
         return b + c * (1.77635683940025e-15 * tc * ts + 0.999999999999998 * tc + -3 * ts + 3 * t);
     };

     $('.newpoints li').hide();
     $('#newpoints .status-bar .silver .fill').html(_meter);
     $('#newpoints .status-bar div.silver .fill').css({'width': '0%'});
     ptitle.text(firstname+ 'Points: ');


    //https://ultrapassport.com/psdf213asdsfsdf/?key=adfsd23435r

    var pointshistory = passport.points_history;

    $.each( pointshistory, function( key, val ) {

        if(val.id) {


            var dateformat = 'MMMM D, YYYY';
            var deldate = '';
            var created_by = '';
            var deleted_by = '';
            var delclass = '';
            var calcamount = Number(val.amount).toLocaleString();
            var calcamountint = Number(val.amount);
            var entrydate = moment(val.created_at).format(dateformat);


            if(calcamountint < 2000 && calcamountint > 100) {
                basepoints = calcamountint;
            }
            if(calcamountint > 25000) {
                eventpoints = calcamountint;
            }
            if(calcamountint < 25000 && calcamountint > 2000) {
                bonuspoints = calcamountint;
            }

        }

    })

    log(basepoints, eventpoints, bonuspoints);

    $('.awardcount').text('+'+Number(eventpoints).toLocaleString());
    $('.bonuscount').text('+'+Number(bonuspoints).toLocaleString());

    if(bonuspoints < 11000) {
        $('.bonustext').text('Attend Your Home Event');
    } else {
        $('.bonustext').text('Attended Another Continent Event');
    }

    // Set prior points
    pointsoutput.text(basepoints);

    setTimeout(function(){

        showResult('Wifi Login Successful', 'success');
        $('.newpoints').fadeIn(10);
        $('#newpoints .status-bar div.silver .fill').css({'width': '0%'});


        if(!eventpoints) {
            showResult('Oops, looks like something went wrong', 'error');
            return;
        }


    }, 100);

    // count attendance points
    setTimeout(function(){

        if(eventpoints) {

            ptitle.text(firstname+ 'Points: +');
            showResult('Awarding attendance points', 'info');
            $('.slide2').slideDown(500, 'easeInOutExpo');
            //$('.slide1').slideUp(500, 'easeInOutExpo');

            var newpoints = eventpoints + basepoints;
            var demo = new CountUp("numcount", basepoints, newpoints, 0, 3.0, options);
            demo.reset();
            demo.start();

            var fillamount = (newpoints / uppgold) *100;

            $('.status-bar div.silver .fill').css({'width': fillamount+'%'});
        }

    }, 1500);


    // count bonus points
    setTimeout(function(){

        if(bonuspoints) {
            showResult('Awarding bonus points', 'info');
            var currentpoints = eventpoints + basepoints;
            var newpoints = bonuspoints + currentpoints;
            var demo = new CountUp("numcount", currentpoints, newpoints, 0, 3.0, options);
            demo.start();
            $('.slide3').slideDown(500, 'easeInOutExpo');
            //$('.slide2').slideUp(500, 'easeInOutExpo');

            var fillamount = (newpoints / uppgold) *100;

            $('.status-bar div.silver .fill').css({'width': fillamount+'%'});
        }

    }, 5000);



    setTimeout(function(){

        if(eventpoints) {

            showResult('Points Redeemed Successfully', 'success');
        }

        $('.slide4').slideDown(500, 'easeInOutExpo');
        /*
            $('.slide2').slideUp(500, 'easeInOutExpo');
            $('.slide3').slideUp(500, 'easeInOutExpo');
            $('.slide1').slideUp(500, 'easeInOutExpo');
            $('.slide3').slideUp(500, 'easeInOutExpo');
            */

        }, 8000);




    var options = {
          useEasing : true,
          useGrouping : true,
          separator : ',',
          decimal : '.',
          prefix : '',
          suffix : '',
          //easingFn: easeOutCubic
    };

/*
        if(bars) {
            var demo = new CountUp("numcount", 1000, 31000, 0, 3.4, options);
            $('.calcpoints2').on('click', function(e) {

                demo.reset();
                demo.start();
                $('#npb>i.count').removeClass('count');

                e.preventDefault();
                bars.toArray().map(function(e){
                    return function(){
                      return $(e).addClass('count').delay(animation_time).promise();
                    };
                }).reduce(function( cur, next ){
                    return cur.then(next);
                }, $().promise());
            });
        }*/



    }
